import { gql } from '@apollo/client';

const pager = gql`
  fragment pager on Page {
    afterId
    sortBy
    direction
    pageSize
  }
`;

const pagination = gql`
  fragment pagination on Pagination {
    currentIndex
    totalCount
    prevPage {
      ...pager
    }
    nextPage {
      ...pager
    }
  }
  ${pager}
`;

const context = gql`
  fragment context on Context {
    serviceName
  }
`;

const messageHeaders = gql`
  fragment messageHeaders on MessageHeaders {
    nbbCorrelationId
  }
`;

const fragments = { pager, pagination, context, messageHeaders };
export default fragments;
